import CourseEnrollment from './CourseEnrollment';
import CourseEnrollmentDetail from './CourseEnrollmentDetail';

export const EnrollmentConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path: '/course_enrollment/detail/:company_calendar_course_id',
            component: CourseEnrollmentDetail
        },
        {
            path: '/course_enrollment',
            component: CourseEnrollment
        },
    ]
};



// WEBPACK FOOTER //
// src/main/content/enrollment/EnrollmentConfig.js